import { motion } from "framer-motion";

export default function ScoreGauge({ value, label, compact = false }) {
  // `compact` keeps the exact same visual identity but shrinks the ring so
  // the score, promo field and unlock CTA fit above the fold on mobile.
  const size = compact ? 120 : 200;
  const stroke = compact ? 5 : 6;
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (value / 100) * circ;

  return (
    <div className="relative flex items-center justify-center" data-testid="score-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#ECE7DF" strokeWidth={stroke} />
        <motion.circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke="#D8C4A5" strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={circ}
          initial={{ strokeDashoffset: circ }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className={`${compact ? "text-[8px]" : "text-[10px]"} kt-tracking-wider uppercase text-[#6F6B66] text-center leading-tight px-2`}>{label}</div>
        <div className={`font-serif ${compact ? "text-3xl" : "text-6xl"} text-[#383633] leading-none mt-0.5`} data-testid="score-value">{value}</div>
        <div className={`${compact ? "text-[9px]" : "text-xs"} text-[#6F6B66] mt-0.5`}>/100</div>
      </div>
    </div>
  );
}
